import { Color } from './color.js';
import createTheme from '../../../../node_modules/@mui/material/styles/createTheme.js';

const muiToOrchestraTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            light: Color.Primary.N200,
            main: Color.Primary.N400,
            dark: Color.Primary.N800,
            contrastText: Color.Base,
        },
        secondary: {
            light: Color.Blue.N200,
            main: Color.Blue.N400,
            dark: Color.Blue.N800,
            contrastText: Color.Base,
        },
        error: {
            light: Color.Red.N200,
            main: Color.Red.N400,
            dark: Color.Red.N800,
            contrastText: Color.Base,
        },
        success: {
            light: Color.Green.N200,
            main: Color.Green.N400,
            dark: Color.Green.N800,
            contrastText: Color.Base,
        },
        warning: {
            light: Color.Orange.N200,
            main: Color.Orange.N400,
            dark: Color.Orange.N800,
            contrastText: Color.Base,
        },
        text: {
            primary: Color.TextPrimary,
            secondary: Color.Neutral.N800,
        },
        background: {
            default: Color.Base,
            paper: Color.Paper,
        },
    },
});

export { muiToOrchestraTheme };
